module.exports = "/_next/static/images/786d1e9fdb1dff8c4aaeb4dc52613d73-savings-xs.jpg";